module.exports = __webpack_public_path__ + "media/maleon-drop.01e34a3b.mp4";